import { ResourceKeys } from './interfaces';

export const parseCompositeId = <T>(keyFields: Array<keyof T>, separator: string = '~') => (value: string): ResourceKeys => {
  const parts = value.split(separator);
  return keyFields.reduce((keys: ResourceKeys, key: keyof T, idx: number) => {
    return Object.assign(keys, { [key]: parts[idx] });
  }, {});
};
